var map = {
	"./bn-BD.json": "5231",
	"./en-US.json": "e0e1",
	"./fil-PH.json": "8d2a",
	"./hi-IN.json": "e72e",
	"./id-ID.json": "7502",
	"./ja-JP.json": "2b1b",
	"./kk-KZ.json": "3cd9",
	"./km-KH.json": "6d3f",
	"./ko-KR.json": "7692",
	"./ky-KG.json": "dbd6",
	"./lo-LA.json": "2cf2",
	"./mn-MN.json": "a7fa",
	"./ms-MY.json": "6579",
	"./my-MM.json": "632c",
	"./ne-NP.json": "7d32",
	"./pt-TL.json": "cfee",
	"./ru-UZ.json": "2999",
	"./si-LK.json": "a931",
	"./ta-LK.json": "8a2f",
	"./th-TH.json": "4e41",
	"./tk-TM.json": "b4ad",
	"./ur-PK.json": "1cd9",
	"./uz-UZ.json": "a261",
	"./vi-VN.json": "f081",
	"./zh-CN.json": "423e",
	"./zh-TW.json": "9ea5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b93c";